<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <Footer ref="publicClass_Footer" />
    <!-- <left-slide /> -->
    <tool-btn></tool-btn>
  </div>
</template>

<script>
import Footer from "./components/footer.vue"; //公共底部
import toolBtn from '@/components/toolBtn'
import leftSlide from "@/components/left_slide"
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },
  components: {
    Footer,
    toolBtn,
    leftSlide
  },
  data() {
    return {
      enum: "",
      isRouterAlive: true //控制视图是否显示的变量
    };
  },
  created() {
    let that = this;
    this.tokenkey = that.$cookies.get("token");
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/Enum")
      .then(function(response) {
        // console.log(response)
        let enums = JSON.stringify(response.data.results);
        sessionStorage.setItem("enum", enums);
      })
      .catch(function() {
        // console.log('sessionStorage错误');
      });
    // 个人数据
    if (this.tokenkey) {
      this.appUserInfo(this.tokenkey);
    }
  },
  mounted() {
    this.initCNZZ();
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    },
    // 个人数据
    appUserInfo(tokenkey) {
      let that = this;
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: tokenkey
          }
        })
        .then(function(result) {
          // // console.log(result)
          that.UserInfos = result.data.results;
          if(tokenkey){
          that.$store.commit('setUserInfo',result.data.results)
          }else{
          that.$store.commit('setUserInfo',{Type:1})
          }
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    },
    initCNZZ() {
      //添加脚本
      const script = document.createElement("script");
      script.src =
        "https://s4.cnzz.com/z_stat.php?id=1280330948&web_id=1280330948";
      script.language = "JavaScript";
      script.id = "cnzz";
      document.body.appendChild(script);
    }
  },
  watch: {
    // 路由变化时发送统计
    $route() {
      if (window._czc) {
        //监听路由变化
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  }
};
</script>

<style>
@import url("./style/reset.css");
@import url("./style/common.css");
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
#app {
  min-width: 1180px;
}

.login_t {
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue